import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from 'containers/Topics/images/search.svg';
import AppContainer from 'components/AppContainer';
import { hidePageHeader } from '../../utils/embedded';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: props => props.backgroundColor,
    paddingTop: 48,
    paddingBottom: 48,
    display: 'flex',
    alignItems: 'center',
  },
  rootWithFilter: {
    paddingBottom: 0,
  },
  title: {
    color: props => props.fontColor,
    textAlign: 'center',
  },
  subtitle: {
    color: props => props.fontColor,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '0.35em',
    },
  },
  filterWrapper: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 40,
  },
  inputSearch: {
    border: '1px solid #E3E3E3',
    borderRadius: 10,
    paddingLeft: 18,
    background: 'white',
    height: 65,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 17,
    width: 712,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}));

const Header = ({ title, subtitle, queryPlaceholder, onQueryChange }) => {
  const clientDetails = useSelector(makeSelectClientDetails());
  const filter = useRef();

  const colors = _get(clientDetails, 'metadata.brandColors', {
    bkg: 'FFFFFF',
    hex: '4B4B4B',
  });
  const classes = useStyles({
    fontColor: `#${colors.hex}`,
    backgroundColor: `#${colors.bkg}`,
  });

  // hide page header if passed when embedding
  if (hidePageHeader()) return null;

  const handleFilterChange = e => {
    if (filter.current) clearTimeout(filter.current);
    const query = e.target.value;

    filter.current = setTimeout(() => {
      onQueryChange(query);
    }, 800);
  };

  return (
    <Grid
      item
      xs={12}
      className={_classNames({
        [classes.root]: true,
        [classes.rootWithFilter]: onQueryChange,
      })}
    >
      <AppContainer>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Typography variant="h3" className={classes.title}>
              {title}
            </Typography>
            {subtitle && (
              <Typography className={classes.subtitle}>{subtitle}</Typography>
            )}
          </Grid>
          {onQueryChange && (
            <Grid item xs={12} className={classes.filterWrapper}>
              <TextField
                placeholder={queryPlaceholder}
                onChange={handleFilterChange}
                classes={{ root: classes.inputSearch }}
                aria-label="Search"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchIcon} alt="" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </Grid>
      </AppContainer>
    </Grid>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  queryPlaceholder: PropTypes.string,
  onQueryChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default Header;
